import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'ez-sso-verify-account',
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  templateUrl: './sso-verify-account.component.html',
  styleUrls: ['./sso-verify-account.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoVerifyAccountComponent {
  ssoName: string = '';
  isBadLoginAttempt: boolean = false;
  supportLink: string = '';

  // These two are just to provide validators for the inputs.
  readonly #fb = inject(FormBuilder);
  form;

  constructor(elementRef: ElementRef) {
    const getAttribute = elementRef.nativeElement.getAttribute.bind(elementRef.nativeElement);

    this.ssoName = getAttribute('sso-name');
    this.isBadLoginAttempt = getAttribute('is-bad-login-attempt');
    this.supportLink = getAttribute('support-link');

    this.form = this.#fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
}
